import { Component } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-stepper',
	template: `
		<vp-stepper
			[ariaDecreaseLabel]="props['ariaDecreaseLabel'] | translate"
			[ariaIncreaseLabel]="props['ariaIncreaseLabel'] | translate"
			[formControl]="formControl"
			[max]="props.max"
			[min]="props.min"
			[readonly]="props.readonly"
			[value]="formControl.value || 0"
			(valueChange)="updateValue($event)"
			ngDefaultControl
		/>
	`,
	standalone: false,
})
export class StepperComponent extends FieldType<FieldTypeConfig> {
	updateValue(value: number): void {
		this.formControl.patchValue(value);
	}
}
